import Link from 'next/link';
import Image from 'next/image';

export function Footer() {
    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8">
                    {/* Logo and description */}
                    <div className="md:col-span-2">
                        <div className="flex items-center space-x-3 mb-4">
                            <Image
                                src="/aihumanit_logo.png"
                                alt="AI Humanit logo"
                                width={48}
                                height={48}
                                className="w-12 h-12 rounded-2xl"
                            />
                            <span className="font-bold text-2xl">
                                <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Human</span>
                                <span className="text-white">it</span>
                            </span>
                        </div>
                        <p className="text-gray-400 mb-4">
                            Transform AI-generated content into natural, human-like text that bypasses detection tools.
                        </p>
                    </div>

                    {/* Quick links */}
                    <div>
                        <h4 className="font-semibold mb-4">Product</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li><Link href="/#features" className="hover:text-white">Features</Link></li>
                            <li><Link href="/#pricing" className="hover:text-white">Pricing</Link></li>
                            <li><Link href="/" className="hover:text-white">Try Now</Link></li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h4 className="font-semibold mb-4">Legal</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li><Link href="/terms" className="hover:text-white">Terms of Service</Link></li>
                            <li><Link href="/privacy" className="hover:text-white">Privacy Policy</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center text-gray-400">
                    <p>&copy; 2025 AI Humanit. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 sm:mt-0">
                        <Link href="/terms" className="hover:text-white text-sm">Terms</Link>
                        <Link href="/privacy" className="hover:text-white text-sm">Privacy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
